import { PureComponent, ReactNode } from 'react';
import { BzitVehicleDetails, Result } from '../../bzit';
import { reportError } from '../../error-handling/reportError';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { Maybe } from '../../types';
import { getVehicleDetails } from './fetcher';

interface RenderProps {
  error: Maybe<unknown>;
  loading: boolean;
  vehicleDetails: Maybe<BzitVehicleDetails>;
}

interface FetchVehicleDetailsProps {
  vehicleId: string;
  render: (props: RenderProps) => ReactNode;
}

type FetchVehicleDetailsState = RenderProps;

class FetchVehicleDetails extends PureComponent<
  FetchVehicleDetailsProps,
  FetchVehicleDetailsState
> {
  public state = {
    error: null,
    loading: true,
    vehicleDetails: null
  };

  public async loadDetails() {
    const { vehicleId } = this.props;
    if (vehicleId) {
      const fetchResult: Result<BzitVehicleDetails> = await getVehicleDetails({ vehicleId });

      if (fetchResult.success) {
        const vehicleDetails = fetchResult.result;

        this.setState({
          vehicleDetails,
          loading: false
        });
      } else {
        reportError('FetchVehicleDetails.loadDetails()', fetchResult.error);
        this.setState({
          error: fetchResult.error,
          loading: false
        });
      }
    }
  }

  public componentDidMount() {
    this.loadDetails();
  }

  public render() {
    const { render } = this.props;
    const children = render(this.state);
    return children;
  }
}

export default withErrorBoundary(FetchVehicleDetails, 'FetchVehicleDetails');
